import React from "react";

const STATUS_STYLES = {
  running: {
    label: "Выполняется",
    pill: "bg-[#EAF7EE] text-[#1F7A3A] border-[#CFEFDB]",
    icon: <i className="fa-solid fa-clock-rotate-left text-[#1F7A3A]" />,
  },
  pause: {
    label: "Пауза",
    pill: "bg-[#FFF3E6] text-[#B45309] border-[#FFE2C2]",
    icon: <i className="fa-solid fa-pause text-[#B45309]" />,
  },
  stopped: {
    label: "Остановлена",
    pill: "bg-[#F3F4F6] text-[#6B7280] border-[#E5E7EB]",
    icon: <i className="fa-solid fa-stop text-[#6B7280]" />,
  },
  error: {
    label: "Ошибка",
    pill: "bg-[#FFECEC] text-[#B91C1C] border-[#FFD0D0]",
    icon: <i className="fa-solid fa-ban text-[#B91C1C]" />,
  },
  done: {
    label: "Готово",
    pill: "bg-[#EAF7EE] text-[#1F7A3A] border-[#CFEFDB]",
    icon: <i className="fa-solid fa-check-double text-[#1F7A3A]" />,
  },
  waiting: {
    label: "Ожидает настройки",
    pill: "bg-[#EDE7FB] text-[#8A59FD] border-[#DED0FF]",
    icon: <i className="fa-solid fa-gear text-[#8A59FD]" />,
  },
};

export default function TaskCard({
  uid,
  title = "Название задачи",
  accounts = 0,
  groups = 0,
  progressValue = 0,

  // ✅ сколько уже сделано действий (подписок)
  accountsAdded = 0,
  dStatsSub = 0,
  // ✅ сколько всего должно быть сделано
  progressTotal = 0,

  status = "waiting",

  // ✅ статистика за сегодня (по этой задаче)
  statsToday = null,

  onEdit,
  onSettings,
  onLogs,

  onStart,
  onPause,
  onStop,
  onResume,
  onStats,

  // ✅ ежедневная статистика
  dailyStats = null,
}) {
  const s = STATUS_STYLES[status] || STATUS_STYLES.running;

  return (
    <div className="bg-white rounded-[18px] border border-[#C8C8C8] shadow-[0_12px_28px_rgba(0,0,0,0.06)] px-6 py-3">
      {/* Top row */}
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="flex items-center gap-2">
            <h3 className="text-[16px] font-semibold text-[#111827]">
              {title}
            </h3>

            <button
              className="text-[#2B7CFF] hover:opacity-80 transition"
              title="Редактировать"
              onClick={() => onEdit?.(uid)}
              type="button"
            >
              <i className="fa-solid fa-pen-to-square" />
            </button>
          </div>

          <div className="mt-1 text-[12px] text-[#6B7280]">
            {accounts} аккаунтов • {groups} групп
            {statsToday && (
              <span>
                {" "}• сегодня:{" "}
                <span className="font-semibold text-[#111827]">
                  {dStatsSub}
                </span>{" "}
                • среднее на аккаунт:{" "}
                <span className="font-semibold text-[#111827]">
                  {statsToday.avgSubscriptionsPerAccountToday}
                </span>
              </span>
            )}
            {dailyStats && (
              <span>
                {" "}• валидных:{" "}
                <span className="font-semibold text-[#111827]">
                  {dailyStats.validAccountsCount}
                </span>
                {" "}• подписались:{" "}
                <span className="font-semibold text-[#111827]">
                  {dailyStats.subscribedAccountsCount}
                </span>
              </span>
            )}
          </div>

          {/* Мини-кнопки управления */}
          <div className="mt-2 flex items-center gap-2 text-[12px]">
            {(status === "waiting" || status === "stopped") && (
              <button
                className="h-7 px-3 rounded-md bg-[#EEF2FF] text-[#374151] hover:opacity-90 transition font-medium"
                onClick={() => onStart?.(uid)}
                type="button"
              >
                Старт
              </button>
            )}

            {status === "done" && (
              <button
                className="h-7 px-3 rounded-md bg-[#EAF7EE] text-[#1F7A3A] hover:opacity-90 transition font-medium"
                onClick={() => onStart?.(uid)}
                type="button"
              >
                Перезапустить
              </button>
            )}

            {status === "running" && (
              <>
                <button
                  className="h-7 px-3 rounded-md bg-[#FFF3D6] text-[#8A6A00] hover:opacity-90 transition font-medium"
                  onClick={() => onPause?.(uid)}
                  type="button"
                >
                  Пауза
                </button>
                
                <button
                  className="h-7 px-3 rounded-md bg-[#FFECEC] text-[#B91C1C] hover:opacity-90 transition font-medium"
                  onClick={() => onStop?.(uid)}
                  type="button"
                >
                  Стоп
                </button>
              </>
            )}

            {status === "pause" && (
              <>
                <button
                  className="h-7 px-3 rounded-md bg-[#EAF7EE] text-[#1F7A3A] hover:opacity-90 transition font-medium"
                  onClick={() => onResume?.(uid)}
                  type="button"
                >
                  Продолжить
                </button>
                
                <button
                  className="h-7 px-3 rounded-md bg-[#FFECEC] text-[#B91C1C] hover:opacity-90 transition font-medium"
                  onClick={() => onStop?.(uid)}
                  type="button"
                >
                  Стоп
                </button>
              </>
            )}
          </div>
        </div>

        <div
          className={[
            "h-7 px-3 rounded-full border text-[12px] font-medium flex items-center gap-2",
            s.pill,
          ].join(" ")}
        >
          {s.icon} {s.label}
        </div>
      </div>

      {/* Progress */}
      <div className="mt-4">
        <div className="h-[7px] w-full rounded-full bg-[#E5E7EB] overflow-hidden">
          <div
            className="h-full rounded-full bg-[#2B7CFF]"
            style={{ width: `${Math.max(0, Math.min(100, progressValue))}%` }}
          />
        </div>

        <div className="mt-3 flex items-center justify-between gap-3 text-[12px]">
          <div className="text-[#6B7280] whitespace-nowrap">
            Прогресс:{" "}
            <span className="text-[#2B7CFF] font-medium">
              {progressValue}%
            </span>
            <span className="text-[#6B7280]">
              {progressTotal > 0 ? ` (${accountsAdded}/${progressTotal})` : ""}
            </span>
          </div>

          <div className="flex items-center gap-4 text-[#6B7280] flex-wrap justify-end">
            <button
              className="flex items-center gap-2 hover:text-[#111827] transition"
              onClick={() => onSettings?.(uid)}
              type="button"
            >
              <i className="fa-solid fa-gear w-3 h-3" />
              Настройки задачи
            </button>

            <button
              className="flex items-center gap-2 hover:text-[#111827] transition"
              onClick={() => onLogs?.(uid)}
              type="button"
            >
              <i className="fa-solid fa-eye w-3 h-3" />
              Показать логи
            </button>

            <button
              className="flex items-center gap-2 hover:text-[#111827] transition"
              onClick={() => onStats?.(uid)}
              type="button"
            >
              <i className="fa-solid fa-chart-simple w-3 h-3" />
              Статистика
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
